import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './shared/styles/globals.css';
import './shared/styles/theme-dev.css';
import './shared/styles/theme-liberty.css';
import './shared/styles/liberty.css';
import { IS_DEV_BUILD, BRAND_NAME } from './shared/config/flavor';
import App from './app';

// Flavor no <html>: cada tema (dev preto+dourado / liberty prata+ouro+azul)
// so' aplica com o seu data-flavor.
document.documentElement.dataset.flavor = IS_DEV_BUILD ? 'dev' : 'liberty';
// Titulo da aba pela marca do build (Cabal Liberty / Cabal).
document.title = IS_DEV_BUILD ? `${BRAND_NAME} · Painel` : BRAND_NAME;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
